import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import Heading from '~/client/components/Heading'
import TermsOfService from '~/client/components/TermsOfService'

export default function AboutPage() {
  return <Container>
    <Paper sx={{p: 2, m: 2, maxWidth: 'sm', mx: 'auto'}} >
      <Heading variant="main">Terms</Heading>
      <TermsOfService/>
    </Paper>
  </Container>
}
